module.exports = __webpack_public_path__ + "7fac599c42ea5816c0bb90036aeffbf6.svg";